<template>
    <div>
      <modals-container name="modal1" />
      <v-dialog/>
      <div class="class_add_top">
        <a class="back" onclick="history.go(-1)">
          返回
        </a>
        <span v-if="isEdit">编辑</span><span v-if="!isEdit">新增</span>计划
      </div>
      <div class="class_add_con">
          <form data-vv-scope="form" novalidate>
            <table width="100%" border="0" cellspacing="0" cellpadding="0">
              <tr class="tita">
                <td class="left_td">培训计划信息</td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td class="left_td pt30">培训主题：</td>
                <td class="pt20"><input type="text" name="title" placeholder="60字以内" class="put_495" v-model="form.title" v-validate="'required'" /></td>
              </tr>
              <div class="error_msg">{{ errors.first('form.title') }}</div>
              <tr>
                <td class="left_td">开放时间：</td>
                <td>
                  <!--input name="beginDate" type="text" id="J-xl" placeholder="选择开始时间" v-model="beginDate" />
                  <input name="endDate" type="text" id="J-xl-2" placeholder="选择结束时间" v-model="endDate" /-->
                  <el-date-picker class="J-xl"
                                  v-model="form.beginDate"
                                  type="date"
                                  value-format="yyyy-MM-dd"
                                  placeholder="选择开始时间">
                  </el-date-picker>
                  至
                  <el-date-picker class="J-xl"
                    v-model="form.endDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择结束时间">
                  </el-date-picker>
                </td>
              </tr>
              <div class="error_msg" v-if="dateValidate">开放时间不能为空, 请选择开始时间/结束时间</div>
              <tr>
                <td class="left_td" valign="top">计划封面：</td>
                <td class="rdiv">
                  <img v-if="form.coverUrl && form.coverUrl!==''" :src="form.coverUrl"  class="upload_img" />
                  <UploadOSS :uploadOSSConf="uploadOSSConf" :DOM_ID="'coverUrl'" v-if="uploadOSSConf.STS!=null"  @success = "OSSUploadSuccess"></UploadOSS>
                  <p class="mt10"><span class="tips_text">建议图片长280px宽150px，支持jpg、jpeg、png，图片大小不超过2MB</span></p>
                </td>
              </tr>
              <tr>
                <td class="left_td pt30" valign="top">培训说明：</td>
                <td valign="top" class="pt20">
                  <Ueditor :value="ueditor.value" :config="ueditor.config" ref="ue"></Ueditor>
                  <br><br>
                </td>
              </tr>
              <tr class="tita">
                <td class="left_td">培训内容</td>
                <td></td>
              </tr>
              <tr>
                <td class="left_td pt20" valign="top">培训内容：</td>
                <td valign="top" class="pt20">
                  <p>
                    <a href="javascript:void(0);" @click="show1" class="kc_btn_up">课程</a>
                    <a href="javascript:void(0);" @click="show2" class="kc_btn_up">考试</a>
                    <a href="javascript:void(0);" @click="show3" class="kc_btn_up">问卷</a>
                  </p><br />
                  <table width="786" border="0" cellspacing="1" cellpadding="0" class="px_content" >
                    <thead>
                    <tr>
                      <td width="50">顺序</td>
                      <td width="130">名称</td>
                      <td width="60">属性</td>
                      <td width="68">类型</td>
                      <td width="68">学分</td>
                      <td width="160" style="padding-left: 5px; padding-right: 5px;">开始时间</td>
                      <td width="160" style="padding-left: 5px; padding-right: 5px;">结束时间</td>
                      <td>操作</td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item, idx) in planItemList" :key="item.id" :class="{tdhang: idx%2}">
                      <td><input name="" type="text" class="put_495 h29put" v-model="item.sort" required /></td>
                      <td>{{item.name}}</td>
                      <td>
                        <select v-model="item.isElective" required>
                          <option value="0">选修</option>
                          <option value="1">必修</option>
                        </select>
                      </td>
                      <td v-if="item.type == '00'">课程</td>
                      <td v-if="item.type == '01'">考试</td>
                      <td v-if="item.type == '02'">问卷</td>
                      <td><input name="" type="text" class="put_495 h29put" v-model="item.credit" required /></td>
                      <td>
                        <!--Laydate :model="item.id" :placeholder="'选择开始时间'" :id="'beginDate' + idx" :propVal="'beginDate'" :initVal="item.beginDate"></Laydate-->
                        <el-date-picker class="J-xl"
                                        v-model="item.beginDate"
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        placeholder="选择开始时间">
                        </el-date-picker>
                      </td>
                      <td>
                        <!--Laydate :model="item.id" :placeholder="'选择结束时间'" :id="'endDate' + idx" :propVal="'endDate'" :initVal="item.endDate"></Laydate-->
                        <el-date-picker class="J-xl"
                                        v-model="item.endDate"
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        placeholder="选择结束时间">
                        </el-date-picker>
                      </td>
                      <td>
                        <a @click.stop="del(idx)"><img src="@/assets/images/px_del@2x.png" /></a>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <p class="mt10">
                    <input name="" type="radio" value="0" v-model="form.learningOrder" />&nbsp;顺序学习　　
                    <input name="" type="radio" value="1" v-model="form.learningOrder" />&nbsp;无序学习
                  </p>
                  <p class="tips_text">说明：顺序一栏中填入数字，数字越小则越靠前，数字相同时表示相同顺序；<br /></p>
                </td>
              </tr>
              <tr class="tita">
                <td class="left_td">设置通过标准</td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td class="left_td" style="padding-top: 20px;" valign="top">通过标准：</td>
                <td valign="top" class="pt20">
                  <p>
                    <input type="checkbox" name="way" value="A" v-model="standardType" />
                    A. 按学分　　
                    <input type="checkbox" name="way" value="B" v-model="standardType" />
                    B. 按考试　　
                    <input type="checkbox" name="way" value="C" v-model="standardType" />
                    C. 按问卷
                  </p>
                  <ul class="mt15 wayOne" v-if="findElem(standardType, 'A') !== -1">
                    <li class="mt10">
                      <span class="criteria_tag">A</span>
                      总学分：{{totalCredits}}分　　　　设置通过最低分：
                      <input name="" type="text"  value="30" class="put_num" v-model="standardTypeSubVal" />
                      分</li>
                  </ul>
                  <!--按学时/学分-->
                  <ul class="mt15 wayTwo" v-if="findElem(standardType, 'B') !== -1">
                    <span class="criteria_tag">B</span>
                    <input type="radio" value="1" v-model="standardTypeSub2" />
                    提交考试　　
                    <input type="radio" value="2" v-model="standardTypeSub2" />
                    通过考试
                  </ul>
                  <!--按学习结果-->
                  <ul class="mt15 wayThree" v-if="findElem(standardType, 'C') !== -1" style="margin-bottom: 15px;">
                    <span class="criteria_tag">C</span>
                    <input type="radio" value="1" v-model="standardTypeSub3" />
                    完成问卷
                  </ul>
                  <!--按考试结果--></td>
              </tr>
              <tr class="tita">
                <td class="left_td">培训计划设置</td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td class="left_td" style="padding-top: 10px;" valign="top">推送范围(显示到前台"任务"列表中)：</td>
                <td class="pt10" valign="top">
                  <p>
                    <input name="see" type="radio" value="2" v-model="form.publicState"/>
                    全员
                    <input name="see" type="radio" value="1" v-model="form.publicState"/>
                    指定人员
                    <input name="see" type="radio" value="0" v-model="form.publicState"/>
                    无
                  </p>
                  <!--指定人员-->
                  <dl class="qa_man_add" v-if="form.publicState == '1'">
                    <dt><a href="javascript:void(0);" @click="showRange" class="on">+选择</a></dt>
                    <dd v-if="publicStateList.length > 0">
                      已选标签{{rangePermission.getPersonTypes(publicStateList).tags}}个,
                      已选用户{{rangePermission.getPersonTypes(publicStateList).users}}个,
                      已选人员{{rangePermission.getPersonTypes(publicStateList).members}}个,
                      已选部门{{rangePermission.getPersonTypes(publicStateList).depts}}个
                      <!--<span v-for="item in publicStateList" :key="item.id" style="background: none; height: 36px; line-height: 36px; text-align: center; width: auto; margin-bottom: 0; margin-left: 0;">{{item.name}}</span>-->
                    </dd>
                  </dl>
                  <!--/指定人员--></td>
              </tr>
              <tr>
                <td class="left_td " valign="top" style="padding-top:20px;">可见范围(显示到前台"计划"列表中)：</td>
                <td class="pt20" valign="top">
                  <p>
                    <input name="see2" type="radio" value="2" v-model="form.scope"/>
                    全员
                    <input name="see2" type="radio" value="1" v-model="form.scope"/>
                    指定人员
                    <input name="see2" type="radio" value="0" v-model="form.scope"/>
                    无
                  </p>
                  <!--指定人员-->
                  <dl class="qa_man_add" v-if="form.scope == '1'">
                    <dt><a href="javascript:void(0);" @click="showScope" class="on">+选择</a></dt>
                    <dd v-if="scopeList.length > 0">
                      已选标签{{rangePermission.getPersonTypes(scopeList).tags}}个,
                      已选用户{{rangePermission.getPersonTypes(scopeList).users}}个,
                      已选人员{{rangePermission.getPersonTypes(scopeList).members}}个,
                      已选部门{{rangePermission.getPersonTypes(scopeList).depts}}个
                      <!--span v-for="item in scopeList" :key="item.id" style="background: none; height: 36px; line-height: 36px; text-align: center; width: auto; margin-bottom: 0; margin-left: 0;">{{item.name}}</span-->
                    </dd>
                  </dl>
                  <!--/指定人员--></td>
              </tr>
              <tr class="tita">
                <td class="left_td">价格设置</td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td class="left_td">是否收费：</td>
                <td>
                  <input name="time" type="radio" value="0" v-model="isFree"/>
                  免费　　
                  <input name="time" type="radio" value="1" v-model="isFree"/>
                  收费
                  <label class="timeLabel" v-if="isFree == '1'">
                    <input name="" class="put_num" type="text"  v-model="form.price"/>
                    元
                  </label>
                </td>
              </tr>
              <tr class="tita">
                <td class="left_td">设置证书</td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td class="left_td" style="padding-top: 10px;" valign="top">证书：</td>
                <td valign="top" class="pt10">
                  <input name="" type="radio" value="1" v-model="isCert"/>&nbsp;需要证书　　
                  <input name="" type="radio" value="2" v-model="isCert"/>&nbsp;不需要证书
                  <p class="mt10" v-if="isCert == '1'">
                    <a href="javascript:void(0);" @click="show4" class="add_bt_all">选择证书</a>
                  <table width="786" border="0" cellspacing="1" cellpadding="0" class="px_content" >
                    <thead>
                    <tr>
                      <td width="50">序号</td>
                      <td width="130">证书名称</td>
                      <td>操作</td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item, idx) in certList" :key="item.id" :class="{tdhang: idx%2}">
                      <td>{{idx+1}}</td>
                      <td>{{item.name}}</td>
                      <td style="width: 50px;">
                        <a v-debounce-click @click="view(item.id)"><img src="@/assets/images/px_preview@2x.png" /></a>
                        <a v-debounce-click @click="delCert(item)"><img src="@/assets/images/px_del@2x.png" /></a>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  </p>
                </td>
              </tr>
            </table>
            <p class="btn_center mt25">
              <input type="button" class="all_btn" value="保存提交" @click="validateForm('form')" />
            </p>
          </form>
      </div>
    </div>
</template>

<script>
  import config from '@/config'
  import api from '@/api'
  import utils from '@/utils'
  import UploadOSS from '@/components/common/upload/uploadOSS.vue'
  import Ueditor from '@/components/common/UE/ue'
  import Laydate from '@/components/common/laydate'
  import CourseSelect from '@/page/byl/org/course/select.vue'
  import ExamSelect from '@/page/byl/org/examination_paper/select.vue'
  import QuizSelect from '@/page/byl/org/questionnaire/select.vue'
  import CertSelect from '@/page/byl/org/cert/select.vue'
  import CertView from '@/page/byl/org/cert/view.vue'
  import ModalBox from '@/components/common/modal/index.vue'
  import rangeManip from '@/components/byl/rangeManip/index.vue'
  import rangePermission from '@/utils/rangePermission'
  import Bus from '@/utils/bus.js'
  export default {
    components: { Ueditor, UploadOSS, CourseSelect, CertSelect, Laydate },
    mounted () {
      this.getSTS()
      this.OSSUploadSuccess()
      // this.initLayDate()
      if (this.isEdit) { // 通过 id 取信息并且赋值
        this.getModel(this.$route.params.id) // 获取表单
        this.$on('data-prepared', function (data) {
          if (data.price && data.price > 0) { this.isFree = '1' }
          this.beginDate = utils.dateFormat(new Date(data.beginDate), 'yyyy-MM-dd hh:mm:ss') // 日期格式化
          this.endDate = utils.dateFormat(new Date(data.endDate), 'yyyy-MM-dd hh:mm:ss') // 日期格式化
          this.ueditor.value = this.$refs.ue.setUEContent(data.description)
          rangePermission.getRange(this.$route.params.id, '05', this.form.publicState).then((r) => {  // 获取推送范围
            this.publicStateList = r
          })
          rangePermission.getScope(this.$route.params.id, '05', this.form.scope).then((r) => {  // 获取推送范围
            this.scopeList = r
          })
          if (data.certId) {
            this.isCert = '1'
          } else {
            this.isCert = '2'
          }
          if (this.passingCriteriaMode == '0') { // 多选通过标准
            var a = data.passingCriteria.split('|')
            var r = []
            for (let i = 0; i < a.length; i++) {
              let o = a[i]
              let n = o.split(':')
              if (n[2]) {
                this.standardTypeSubVal = n[2]
              }
              switch (o.split(':')[0]) {
                case "B": {
                  this.standardTypeSub2 = o.split(':')[1]
                  break
                }
                case "C": {
                  this.standardTypeSub3 = o.split(':')[1]
                  break
                }
              }
              r.push(o[0])
            }
            this.standardType = r
          } else if (this.passingCriteriaMode == '1') {
            this.standardType = data.passingCriteria.split(':')[0]  // "A:1:30"
            switch (this.standardType) {
              case "B": {
                this.standardTypeSub2 = data.passingCriteria.split(':')[1]
                break
              }
              case "C": {
                this.standardTypeSub3 = data.passingCriteria.split(':')[1]
                break
              }
            }
            this.standardTypeSubVal = data.passingCriteria.split(':')[2]
          }
          // for (let i = 0; i < data.planItemList.length; i++) { // 时间显示
          //   let p = data.planItemList[i]
          //   p.beginDate = utils.dateFormat(new Date(p.beginDate), 'yyyy-MM-dd hh:mm:ss') // 日期格式化
          //   p.endDate = utils.dateFormat(new Date(p.endDate), 'yyyy-MM-dd hh:mm:ss') // 日期格式化
          // }
          this.planItemList = data.planItemList
          this.oldPlanItemListCounts = data.planItemList.length
          this.getCertListByIds([data.certId])
        });
      }
      Bus.$on('selectedCourses', (data) => {
        this.getCourseListByIds(data)
      })
      Bus.$on('selectedExams', (data) => {
        this.getExamListByIds(data)
      })
      Bus.$on('selectedQuizes', (data) => {
        this.getQuizListByIds(data)
      })
      Bus.$on('selectedCert', (data) => {
        if (data.length > 1) {
          this.$toasted.show('一个计划只能选择一个证书')
        } else {
          this.getCertListByIds(data)
        }
      })
    },
    data () {
      return {
        rangePermission:  rangePermission,
        form: {
          learningOrder: '0',
          publicState: '0',
          scope: '2'
        },
        beginDate: '',
        endDate: '',
        ueditor: {
          value: '',
          config: {
            initialFrameWidth: 790,
            initialFrameHeight: 227
          }
        },
        uploadOSSConf: { showMode: '1', style: 'img_upload', typeArr: 'image/png,image/jpg,image/jpeg', catalog: 'byl', fileName: '', maxSize: '2000000', STS: null },
        currentCs: [], // 已选的课程
        currentEs: [], // 已选的考卷
        currentQs: [], // 已选的问卷
        oldPlanItemListCounts: 0, // 记录一下旧PlanItemList的数量
        planItemList: [], // 所有选择的资源（课程，考试，问卷)
        publicStateList: [], // 权限范围
        scopeList: [],
        certList: [], // 选择的证书列表
        excludeCourseIds: [],
        passingCriteriaMode: '0', // 通过标准模式： '0'：多选 '1': 单选
        isCert: '1',
        standardType: [],
        standardTypeSubVal: '',
        standardTypeSub2: '1',
        standardTypeSub3: '1',
        dateValidate: false,
        totalCredits: 0,
        isFree: '0',
        prefix: this.$route.meta.prefix || '',
        labelsMap: {
          'user_name': '刘海',
          'cert_code': '20080001',
          'cert_date': '2018-09-18',
          'user_idCardNo': '310xxxxxxxxxxx0987',
          'userplan_achievement': '35',
          'qrCodeUrl_1': '二维码串'
        }
      }
    },
    computed: {
      isEdit () {
        return this.$route.params.id && this.$route.params.id !== 'void'
      }
    },
    watch: {
      'planItemList': {
        handler (newVal, oldVal) {
          if (newVal.length == 0) {
            this.totalCredits = 0
          } else {
            var result = 0;
            for (let i = 0; i < this.planItemList.length; i++) {
              let p = this.planItemList[i]
              if (p.credit) {
                result += Number(p.credit) // 计算总学分
              }
            }
            this.totalCredits = result
          }
        },
        deep: true
      },
      standardTypeSubVal (val) {
        if (val > Number(this.totalCredits)) {
          this.standardTypeSubVal = val
        }
      }
    },
    methods: {
      findElem: utils.findElem,
      popup (msg) {
        this.$toasted.show(msg)
      },
      confirmBox (o) {
        var that = this
        this.$modal.show('dialog', {
          title: '提交',
          text: '确认提交吗？',
          buttons: [
            {
              title: '确认',
              default: false,
              handler: utils.debounce(() => {
                if (o.yes && o.yes instanceof Function) {
                  o.yes()
                  that.$modal.hide('dialog') // !!!必须清掉模态框，否则在别的页面按enter键会触发方法的
                }
              }, 1000)
            },
            {
              title: '取消'
            }
          ]
        })
      },
      validateForm (scope) {
        var bus = this
        var _dealCriteria = function () { // 设置通过标准
          if (bus.passingCriteriaMode == '0') { // 多选
            bus.form.passingCriteria = [] // 数组记录
            for (let i = 0; i < bus.standardType.length; i++) {
              let o = bus.standardType[i]
              switch (o) { // 设置标准
                case 'A': {
                  if (utils.findElem(bus.form.passingCriteria, o) == -1) {
                    bus.form.passingCriteria.push(o + ':1:' + bus.standardTypeSubVal)
                  }
                  break
                }
                case 'B': {
                  if (utils.findElem(bus.form.passingCriteria, o) == -1) {
                    bus.form.passingCriteria.push(o + ':' + bus.standardTypeSub2)
                  }
                  break
                }
                case 'C': {
                  if (utils.findElem(bus.form.passingCriteria, o) == -1) {
                    bus.form.passingCriteria.push(o + ':' + bus.standardTypeSub3)
                  }
                  break
                }
              }
            }
            bus.form.passingCriteria = utils.arr2str(bus.form.passingCriteria, '|')
          } else if (bus.passingCriteriaMode == '1') { // 单选
            switch (bus.standardType) { // 设置标准
              case 'A': {
                bus.form.passingCriteria = bus.standardType + ':1:' + bus.standardTypeSubVal
                break
              }
              case 'B': {
                bus.form.passingCriteria = bus.standardType + ':' + bus.standardTypeSub2
                break
              }
              case 'C': {
                bus.form.passingCriteria = bus.standardType + ':' + bus.standardTypeSub3
                break
              }
            }
          }
        }
        var _dealParams = function () { // 处理发送给后台的数据
          var planItemList = []
          // bus.form.beginDate = new Date(bus.beginDate)
          // bus.form.endDate = new Date(bus.endDate)
          if (bus.isFree == 0) { bus.form.price = 0 }
          if (bus.certList.length > 0) {
            bus.form.certId = bus.certList[0].id // 证书
          }
          if (bus.isCert == '2') {
            delete bus.form.certId
          }
          bus.form.description = bus.$refs.ue.getUEContent()
          bus.form.title = utils.handleXss(bus.form.title)
          for (let i = 0; i < bus.planItemList.length; i++) {
            let p = bus.planItemList[i]
            let o = {}
            o.beginDate = new Date(p.beginDate)
            o.endDate = new Date(p.endDate)
            o.credit = p.credit
            o.sort = p.sort
            if (bus.form.learningOrder == '1') {
              o.sort = 0
            } else {
              o.sort = p.sort
            }
            o.isElective = p.isElective
            o.itemId = p.itemId ? p.itemId : p.id // !!!Careful
            o.name = p.name
            o.type = p.type
            o.coverUrl = p.coverUrl
            planItemList.push(o)
          }
          bus.form.planItemList = planItemList // 培训内容
          _dealCriteria()
        }
        this.$validator.validateAll(scope).then(function (result) {
          if (result) {
            if (bus.isEdit) { // 编辑
              _dealParams()
              if (bus.planItemList.length < bus.oldPlanItemListCounts && (bus.form.publicState == '1' || bus.form.publicState == '2')) { // 内容数量减少，并且已经分配了人员
                bus.popup('该计划已经分配出去, 请不要减少培训内容数量')
              } else {
                 bus.confirmBox({
                  yes: function () {
                    api.post(config.planApiPath, '/trainingplans/modify/' + bus.form.id, bus.form, function (r) { // 正常
                      bus.popup(r.message)
                      rangePermission.saveTo(bus.form.id, '05', {type: bus.form.publicState, value: bus.publicStateList}, {type: bus.form.scope, value: bus.scopeList})
                      bus.$router.push(bus.prefix + '/org/planList')
                    })
                  }
                })
              }
            } else { // 新增
              if (!bus.form.beginDate || !bus.form.endDate) {
                bus.dateValidate = true
                bus.popup('开放时间不能为空')
              } else {
                bus.confirmBox({
                  yes: function () {
                    _dealParams()
                    api.post(config.planApiPath, '/trainingplans', bus.form, function (r) { // 正常
                      bus.popup('创建培训计划成功')
                      rangePermission.saveTo(r.data.id, '05', {type: bus.form.publicState, value: bus.publicStateList}, {type: bus.form.scope, value: bus.scopeList})
                      bus.$router.push(bus.prefix + '/org/planList')
                    })
                  }
                })
              }
            }
          } else {
            bus.$toasted.show('请确保信息正确与完整')
            return false
          }
        })
      },
      createIds (arr, type) {
        var r = []
        for (var i = 0; i < arr.length; i++) {
          let t = arr[i].type
          let s = arr[i]
          var _pushId = function () {
            if (s.itemId) {
              r.push(s.itemId)
            } else {
              r.push(s.id)
            }
          }
          if (t == type) {
            _pushId()
          }
        }
        return r
      },
      show1 () {
        var that = this
        let excludeIds = this.createIds(this.planItemList, '00')
        this.$modal.show(CourseSelect, {
          ids: excludeIds
        })
      },
      show2 () {
        var that = this
        let excludeIds = this.createIds(this.planItemList, '01')
        this.$modal.show(ExamSelect, {
          ids: excludeIds
        })
      },
      show3 () {
        var that = this
        let excludeIds = this.createIds(this.planItemList, '02')
        this.$modal.show(QuizSelect, {
          ids: excludeIds
        })
      },
      show4 () { // 选择证书弹出框
        let excludeIds = this.certList
        this.$modal.show(CertSelect, {
          ids: excludeIds
        })
      },
      view (id) {
        this.$modal.show(CertView, {
          id: id,
          p: this.labelsMap
        })
      },
      OSSUploadSuccess (r) {
        if (r && r != '') {
          this.$set(this.form, r.dom_id, r.res.requestUrls[0])
        }
      },
      getSTS () {
        this.$api.get(this.$global.resourceApiPath, '/common/getSTS', {}, r => {
          let STS = [r.data.expiration, r.data.accessKeyId, r.data.accessKeySecret, r.data.securityToken, r.data.endpointClean, r.data.bucket, r.data.region]
          this.uploadOSSConf.STS = STS
        })
      },
      getCourseListByIds (idsArr) {
        this.$api.get(this.$global.courseApiPath, '/course/batch', {ids: utils.arr2str(idsArr)}, r => {
          this.currentCs = r.data
          for (var m = 0; m<this.currentCs.length; m++) { // 给每一个课程对象赋值“课程”
            this.currentCs[m].type = '00'
            this.currentCs[m].beginDate = ''
            this.currentCs[m].endDate = ''
            this.currentCs[m].isElective = '0'
            this.currentCs[m].coverUrl = this.currentCs[m].faceUrl
          }
          this.planItemList = this.planItemList.concat(this.currentCs)
        })
      },
      getCertListByIds (ids) {
        var that = this
        this.$api.post(this.$global.certApiPath, '/cert-templates/search', {includedIds: ids, isPublished: '1'}, r => {
          that.certList = r.data
        })
      },
      getExamListByIds (ids) {
        this.$api.post(this.$global.examApiPath, '/examPaper/search', {type: '1', idList: utils.arr2str(ids)}, r => {
          this.currentEs = r.data
          for (var m = 0; m<this.currentEs.length; m++) { // 给每一个课程对象赋值“考卷”
            this.currentEs[m].name = this.currentEs[m].title
            this.currentEs[m].type = '01'
            this.currentEs[m].beginDate = ''
            this.currentEs[m].endDate = ''
            this.currentEs[m].isElective = '0'
            this.currentEs[m].coverUrl = this.currentEs[m].faceUri
          }
          this.planItemList = this.planItemList.concat(this.currentEs)
        })
      },
      getQuizListByIds (ids) {
        this.$api.post(this.$global.examApiPath, '/examPaper/search', {type: '2', idList: utils.arr2str(ids)}, r => {
          this.currentQs = r.data
          for (var m = 0; m<this.currentQs.length; m++) { // 给每一个课程对象赋值“考卷”
            this.currentQs[m].name = this.currentQs[m].title
            this.currentQs[m].type = '02'
            this.currentQs[m].beginDate = ''
            this.currentQs[m].endDate = ''
            this.currentQs[m].isElective = '0'
            this.currentQs[m].coverUrl = this.currentQs[m].faceUri
          }
          this.planItemList = this.planItemList.concat(this.currentQs)
        })
      },
      getModel (id) {
        var that = this
        api.get(config.planApiPath, '/trainingplans/' + id, null, function (r) { // 正常
          that.form = r.data
          that.$emit('data-prepared', that.form)
        })
      },
      del (idx) {
        this.planItemList.splice(idx, 1)
      },
      delCert (item) {
        var idx = utils.findElem(this.certList, 'id', item)
        this.certList.splice(idx, 1)
      },
      initLayDate () {
        var self = this
        var startTime = laydate.render({
          elem: '#J-xl',
          type: 'datetime',
          done: function (value, date) {
            endTime.config.min ={
              year:date.year,
              month:date.month-1, //关键
              date: date.date,
              hours: 0,
              minutes: 0,
              seconds : 0
            };
            self.beginDate=value;
          }
        });
        var endTime = laydate.render({
          elem: '#J-xl-2',
          type: 'datetime',
          done: function (value, date) {
            startTime.config.max={
              year:date.year,
              month:date.month-1, //关键
              date: date.date,
              hours: 0,
              minutes: 0,
              seconds : 0
            }
            self.endDate=value;
          }
        });
      },
      showRange () {
        var that = this
        this.$modal.show(ModalBox, {
          opts: {
            title: '设置推送范围',
            styles: {
              width: '960',
              height: String(0.8242 * window.screen.availHeight)
            },
            currentComponent: {
              name: 'range',
              template: rangeManip,
              outputsKey: 'outputs', // 该组件对外输出数据时，定义的key值
              inputs: that.publicStateList // 向组件内传入的数据, 一般用于初始化
            },
            yes (val) { // 点击确认后要做的事情
              that.publicStateList = val
            },
            closed () { // 这里要判断, 只有新增状态下需要清空
              if (that.$route.params.id == 'void') {
                that.publicStateList = []
              }
            }
          }
        })
      },
      showScope () {
        var that = this
        this.$modal.show(ModalBox, {
          opts: {
            title: '设置可见范围',
            styles: {
              width: '960',
              height: String(0.8242 * window.screen.availHeight)
            },
            currentComponent: {
              name: 'range',
              template: rangeManip,
              outputsKey: 'outputs', // 该组件对外输出数据时，定义的key值
              inputs: that.scopeList // 向组件内传入的数据, 一般用于初始化
            },
            yes (val) { // 点击确认后要做的事情
              that.scopeList = val
            },
            closed () { // 这里要判断, 只有新增状态下需要清空
              if (that.$route.params.id == 'create') {
                that.scopeList = []
              }
            }
          }
        })
      }
    }
  }
</script>

<style scoped>
  input[type=checkbox] { opacity: 1; }
  .criteria_tag { display: inline-block; width: 12px; height: 12px; line-height: 12px; padding: 5px; background: #ff3633; color: white; padding: 5px; }
</style>



// WEBPACK FOOTER //
// src/page/byl/org/plan/model.vue